import { render, staticRenderFns } from "./ColorSwatch.vue?vue&type=template&id=281ef2ba&scoped=true&"
import script from "./ColorSwatch.vue?vue&type=script&lang=js&"
export * from "./ColorSwatch.vue?vue&type=script&lang=js&"
import style0 from "./ColorSwatch.vue?vue&type=style&index=0&id=281ef2ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281ef2ba",
  null
  
)

export default component.exports